import React, { useCallback, useMemo, useState } from "react";
import { DesktopTimePicker } from '@mui/x-date-pickers/DesktopTimePicker';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import moment from "moment";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import './date-picker.scss'

// Use the explicit <DesktopTimePicker /> digital list / lighter digital clock
// for all browsers. MUI X's MobileTimePicker analog clock stutters on Safari and
// is inconsistent with the rest of the form inputs.

export default function TimePickerInput({ maxDate, disabled, disable, label, placeholder, required, validation = [], value, onChange, error, touched, dataCy = "", ...props }) {
    let isRequired = required || (validation.includes('required') && !(validation.includes('skip') || validation.includes('optional')));
    // Controlled open state removes the open button and lets the whole input
    // field open the popper on click.
    const [open, setOpen] = useState(false);
    const isDisabled = disabled || disable;
    const pickerValue = useMemo(() => value ? moment.utc(value) : null, [value]);
    const handleOpen = useCallback(() => {
        if (!isDisabled) setOpen(true);
    }, [isDisabled]);
    const handleClose = useCallback(() => setOpen(false), []);
    const handleChange = useCallback((newValue) => {
        if (!onChange) return;
        if (newValue === null) {
            onChange(null);
            return;
        }
        if (moment.isMoment(newValue) && newValue.isValid()) onChange(moment(newValue).toISOString());
    }, [onChange]);

    return (
        <div className="form-group">
            <div className="input-block datepicker-block" data-cy={dataCy} onClick={handleOpen}>
                <span className="input-icon icon-grey"><AccessTimeIcon /></span>
                <label className="input-label">
                    <span>{label || placeholder || ''} {isRequired ? <span className='text-danger'>*</span> : null}</span>
                </label>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DesktopTimePicker
                        id={props.name}
                        margin='dense'
                        inputVariant='outlined'
                        value={pickerValue}
                        onChange={handleChange}
                        disabled={isDisabled}
                        open={open}
                        onOpen={handleOpen}
                        onClose={handleClose}
                        disableOpenPicker
                        slotProps={{
                            popper: { className: 'contractable-picker-popper contractable-time-picker-popper', style: { zIndex: 10000 } },
                            desktopPaper: { className: 'contractable-picker-paper' }
                        }}
                        {...props}
                    />
                </LocalizationProvider>
                <br />
                {touched && error && <span style={{ color: 'red' }}>{error}</span>}
            </div>
        </div>
    );
}
